// Query the ensemble api in order to get their thumnail images for the gallery


async function TLAW_ENSEMBLE_get_video_info_by_id(video_id) {
    const url = "https://ensemble.temple.edu/app/simpleapi/video/show.xml/" + video_id;
    let video_info;
    
    try {
        video_info = await jQuery.ajax(url, "xml");
    }
    catch (e) {
        console.log(e);
    }

    return video_info;
}

function TLAW_ENSEMBLE_get_video_thumbnail_url(video_data) {
    let thumbnail_url;

    if(video_data) {
        try {
            thumbnail_url = video_data.activeElement.getElementsByTagName("imageUrl")[0].textContent;
        }
        catch (e) {
            console.log(e);
        }
    }

    return thumbnail_url;
}

async function TLAW_ENSEMBLE_get_gallery_thumbnails() {
    //for each gallery block on page
    const galleries = document.getElementsByClassName("gallery-block");

    for (const gallery of galleries) {
        const thumbnails = gallery.getElementsByClassName("ensemble-thumbnail");

        for (const thumbnail of thumbnails) {
            const video_id = thumbnail.getAttribute("data-video-id");
            const video_data = await TLAW_ENSEMBLE_get_video_info_by_id(video_id);
            const thumbnail_url = TLAW_ENSEMBLE_get_video_thumbnail_url(video_data);

            if (thumbnail_url) {
                const image_element = thumbnail.getElementsByClassName("gallery-thumbnail-image")[0];

                //Inset the link into the thumbnail image element
                image_element.src = thumbnail_url;
            }
        }
    }
}

TLAW_ENSEMBLE_get_gallery_thumbnails();